export default __webpack_public_path__ + "static/media/Bossa-ExpandedBold.a2685160.woff2";